"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignAndSendAllTransactions = void 0;
/** Name of the feature */
exports.SignAndSendAllTransactions = 'solana:signAndSendAllTransactions';
//# sourceMappingURL=signAndSendAllTransactions.js.map